/**
   * Manage Newsletter Popup based on Cookie
   *
   */
function ensureUtility(callback) {
  if (typeof Utility !== 'undefined') {
    callback();
    return;
  }

  document.addEventListener('UtilityReady', () => callback(), { once: true });
}

(function manageNewsletter() {
    const customerPosted = (window.location.href.search('[?&]customer_posted=true') !== -1);
    const $newsletterPopup = document.querySelector('#PopupModal-newsletter .modal');
  
    if(!$newsletterPopup){
      return;
    }
  
    const popupDelay = $newsletterPopup.dataset.popup_delay * 1000;
    const daysUntil = $newsletterPopup.dataset['period_until'];
    const newsletterPopupEnabled = $newsletterPopup.dataset['newsletter_enabled'] == "false" ? false : true;
   const getNewsletterStatus = () => (typeof Utility !== 'undefined' ? Utility.getCookie('newsletter_popup_status') : '');
   const newsletterPopupStatus = getNewsletterStatus();
    const today = new Date();
    
    const expirationDate = new Date();
    expirationDate.setDate(today.getDate() + daysUntil);
    const time = expirationDate.getTime();
    const expireTime = time + 1000 * 36000;
    expirationDate.setTime(expireTime);
  
    // After successful registration get the 'customer_posted' parameter from URL and show popup for confirmation
    if (customerPosted) {
      $newsletterPopup.classList.add('open');
      SiteOverlay.showOverlay();
    }
  
    let newsletterCloseBtn = document.querySelector('[data-newsletter-close-btn]');
    const bindCloseListener = () => {
      if(newsletterCloseBtn){
        newsletterCloseBtn.addEventListener('click', () => {
          if (typeof Utility !== 'undefined' && typeof Utility.setCookie === 'function') {
            Utility.setCookie('newsletter_popup_status', 'disabled', parseInt(daysUntil, 10) || 30);
          } else {
            document.cookie = `newsletter_popup_status=disabled;expires=${expirationDate.toGMTString()};path=/`;
          }
          $newsletterPopup.classList.remove('open');
          SiteOverlay.hideOverlay();
        });
      }
    };

    if (typeof Utility === 'undefined') {
      ensureUtility(bindCloseListener);
    } else {
      bindCloseListener();
    }
  
    // do not show the popup if the disabled status cookie exists
    if (newsletterPopupStatus === 'disabled' || !newsletterPopupEnabled) {
      return;
    }
  
   const showPopup = () => {
     $newsletterPopup.classList.add('open');
     SiteOverlay.showOverlay();
   };

   setTimeout(() => {
     showPopup();
   }, popupDelay);
})();